import { render } from "./work-order-history-detail.vue?vue&type=template&id=bb9f69e8"
import script from "./work-order-history-detail.vue?vue&type=script&lang=js"
export * from "./work-order-history-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__